import * as React from "react";
import ConnectWalletModal from "@/components/atomics/connect-wallet-modal";
import { useState, useRef, useEffect } from "react";
import CreateCollectionButton from "../../molecules/create-collection/create-collection-button";
import DailyNewsCard from "../../molecules/create-collection/daily-news-card";
import { dailyNewsData, collectionData } from "../../../data/daily-news";
import CollectionCard from "../../../components/molecules/create-collection/collection-card";
import { useNavigate } from "react-router-dom";
import { useWallet } from "@/context/WalletContext";
import { useSnackbar } from "notistack";
import { backend } from "@/services/backend";
import { CollectionDataCache } from "@/types/collection";
import LoadMoreButton from "@/components/atomics/load-more-button";
import { useCollection } from "@/context/CollectionContext";
import MotionModal from "@/components/atomics/motion-modal";
import { useTonConnectUI } from "@tonconnect/ui-react";
import LoadingStatus from "@/components/atomics/loading-status";

export default function CreateCollection() {
  const displayCount = 4;
  const { initialize } = useCollection();
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { isConnected, toggleMenu } = useWallet();
  const [tonConnectUI] = useTonConnectUI();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [lastCollections, setLastCollections] = useState<CollectionDataCache[]>(
    []
  );
  const [pinnedCollections, setPinnedCollections] = useState<
    CollectionDataCache[]
  >([]);

  const [showWalletConnectionModal, setShowWalletConnectionModal] =
    useState(false);

  const handleConnectWallet = async () => {
    try {
      await tonConnectUI.openModal();
    } catch (error) {
      console.error("Failed to open wallet connection modal:", error);
    }
  };

  useEffect(() => {
    initialize();

    Promise.all([
      /* Promise.all(
        pinnedCollectionAddresses.map((address) =>
          backend.getCollectionData(address)
        )
      ), */

      backend.getAllLastCollectionsWithOffset(0, displayCount),
      backend.getAllLastCollectionsWithOffset(0, displayCount + 2, true),
    ]).then(([latest, pinned]) => {
      setLastCollections(latest);
      setPinnedCollections(pinned);
      setOffset(1);
      setHasMore(latest.length === displayCount);
      setIsReady(true);
    });
  }, []);

  useEffect(() => {
    if (isConnected) {
      setShowWalletConnectionModal(false);
    }
  }, [isConnected]);

  const handleCreateCollection = () => {
    if (!isConnected) {
      setShowWalletConnectionModal(true);
      enqueueSnackbar("Wallet is not connected!", {
        SnackbarProps: {
          onClick: () => {
            closeSnackbar();
          },
        },
        variant: "error",
        autoHideDuration: 1000,
      });
      // toggleMenu();
      return;
    }
    navigate("/collection/create/1");
  };

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const isAtEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 10; // Adding small buffer

      if (isAtEnd) {
        container.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      } else {
        container.scrollBy({
          left: 163, // Width of one card + gap
          behavior: "smooth",
        });
      }
    }
  };

  const handleLoadMore = () => {
    setIsLoading(true);

    backend
      .getAllLastCollectionsWithOffset(offset * displayCount, displayCount)
      .then(collections => {
        setLastCollections(prev => [...prev, ...collections]);
        const gotFullPage = collections.length === displayCount;
        setHasMore(gotFullPage);
        if (gotFullPage) {
          setOffset(offset + 1);
        }
        setIsLoading(false);
      });
  };

  if (!isReady) {
    return (
      <LoadingStatus
        status="loading"
        text={["Loading..."]}
        className="bg-black"
      />
    );
  }

  return (
    <div className="w-full">
      <MotionModal isOpen={showWalletConnectionModal}>
        <ConnectWalletModal
          onClose={() => setShowWalletConnectionModal(false)}
          onClick={() => setShowWalletConnectionModal(false)}
          onConnect={handleConnectWallet}
        />
      </MotionModal>

      <div className="relative w-full h-[300px] ">
        <img src="/background.png" />
        <div className="w-[82%] absolute top-[26px] left-1/2  -translate-x-1/2">
          <div className="w-full">
            <img src="/nft-logo.png" />
          </div>
          <div className="pt-[12px] pl-[10px] pr-[10px] flex flex-col  justify-center text-[15px] ">
            <span className="text-center">
              SIMPLIFYING <a className="text-[#0099FE]">WEB3</a> MONETIZATION
              FOR DEVELOPERS
            </span>
          </div>
        </div>
        <CreateCollectionButton
          className="w-[163px]"
          onClick={() => handleCreateCollection()}
        />
      </div>
      {/* <div className="pl-[12px] pt-[116px]">
                <div className="pl-[20px] pb-[23px]">
                    <span className="text-[32px]">DAILY NEWS</span>
                </div>
                <div 
                 ref={scrollContainerRef}
                className="flex gap-[10px] pb-[10px] overflow-hidden">
                    {dailyNewsData.map((item, index) => (
                        <DailyNewsCard 
                            key={index}
                            title={item.title}
                            description={item.description}
                            image={item.image}
                            className="w-[153px] flex-shrink-0" />
                    ))}
                </div>
                <div 
                    className="flex justify-end items-center pr-[36px] pt-[17px] pb-[23px] cursor-pointer"
                    onClick={handleScrollRight} >
                    <span className="text-[#0099FE] text-[24px]">MORE</span>
                    <div className="w-[19px] h-[19px]">
                        <img src="/assets/direction.svg" />
                    </div>
                </div>
            </div> */}
      <div className="bg-black h-[170px]"></div>
      <div className="w-full bg-white pr-[10px] pl-[10px]  pt-[40px] pb-[10px] ">
        <div className="pl-[20px] pb-[23px]">
          <span className="text-[30px] text-black">FEATURED</span>
        </div>
        <div className="grid grid-cols-2 gap-[10px] transition-all duration-500 ease-in-out">
          {pinnedCollections.map((collection, index) => (
            <CollectionCard
              key={index}
              className={`w-full flex-shrink-0 transition-all duration-300 ease-in-out hover:cursor-pointer ${
                isLoading ? "animate-pulse opacity-60" : "opacity-100"
              }`}
              onClick={() => navigate(`/collection/${collection.address}`)}
              data_url={collection.data_url}
              value={collection.price ? collection.price / 1000000000 : 0}
              totalMintCount={collection.mint_limit ?? 0}
              currentMintedCount={collection.next_item_index ?? 0}
              mint_time_limit={collection.mint_time_limit}
            />
          ))}
        </div>
      </div>
      <div className="w-full bg-white pr-[10px] pl-[10px]  pt-[15px] pb-[20px]">
        <div className="pl-[20px] pb-[23px]">
          <span className="text-[30px] text-black">NEW COLLECTIONS</span>
        </div>
        <div className="grid grid-cols-2 gap-[10px] transition-all duration-500 ease-in-out">
          {lastCollections.map((item, index) => (
            <CollectionCard
              key={index}
              className={`w-full flex-shrink-0 transition-all duration-300 ease-in-out hover:cursor-pointer ${
                isLoading ? "animate-pulse opacity-60" : "opacity-100"
              }`}
              onClick={() => navigate(`/collection/${item.address}`)}
              data_url={item.data_url}
              value={item.price / 1000000000}
              totalMintCount={item.mint_limit}
              currentMintedCount={item?.next_item_index ?? 0}
              mint_time_limit={item.mint_time_limit}
            />
          ))}
        </div>

        <LoadMoreButton
          isLoading={isLoading}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
        />
      </div>
    </div>
  );
}
